export { default } from "./src/panel";
